import React, { FC, useEffect, useState, useRef, ChangeEvent } from "react";
// import Checkbox from "shared/Checkbox/Checkbox";
// import CommonLayout from "./CommonLayout";
// import NcInputNumber from "components/NcInputNumber/NcInputNumber";
// import FormItem from "./FormItem";
// import Input from "shared/Input/Input";

import { AuthorType, ListingDataType } from "data/types";
import { useLocation } from 'react-router-dom';
import ButtonPrimary from "shared/Button/ButtonPrimary";
import ButtonSecondary from "shared/Button/ButtonSecondary";
import { useNavigate } from 'react-router-dom';
import ReactS3Client from 'react-aws-s3-typescript';
import { s3Config } from '../../utils/s3Config';
import { FadeLoader } from 'react-spinners';

export interface PageAddListing4Props { }





const PageAddListing4: FC<PageAddListing4Props> = () => {

  const location = useLocation();
  const propertyInfo = location.state;
  const agent = propertyInfo.agent as AuthorType;
  const property = propertyInfo.property as ListingDataType;
  const [coverImage, setCoverImage] = useState('');
  const [galleryImgs, setGalleryImgs] = useState<string[]>();
  const navigate = useNavigate();
  const [loadingCover, setLoadingCover] = useState(false);
  const [loadingImages, setLoadingImages] = useState(false);
  const fileInputRef = useRef<HTMLInputElement | null>(null);
  const CoverInputRef = useRef<HTMLInputElement | null>(null);





  useEffect(() => {
    checkValues();
  }, []);

  useEffect(() => {
  }, [galleryImgs]);

  const checkValues = () => {

    setCoverImage(property.featuredImage || '');
    setGalleryImgs(property.galleryImgs || []);

  }

  const toNextStep = () => {
    if (!coverImage || !galleryImgs || galleryImgs.length === 0) {
      console.error("Cover image or gallery images cannot be empty");
      
      return;
    }
  
    property.featuredImage = coverImage;
    property.galleryImgs = galleryImgs;
  
    const propertyInfo = {
      property,
      agent,
    };
  
    navigate('/add-listing-7', { state: propertyInfo });
  };

  const handleCoverImageChange = async (event: React.ChangeEvent<HTMLInputElement>) => {
    const file = event.target.files && event.target.files[0];
    const s3 = new ReactS3Client({
      ...s3Config,
      dirName: 'profiles'
    });


    if (file) {
      try {
        setLoadingCover(true);
        // const res = await s3.uploadFile(file, filename);
        const res = await s3.uploadFile(file);
        console.log(res);
        // if (agent) {
        setCoverImage(res.location);
        setLoadingCover(false);
        // updateAgentAvatar(res.location);
        //}
        // updateAgentData();

      } catch (exception) {
        console.log(exception);
        setLoadingCover(false);
      }
    }
  };

  const handleAddImage = () => {
    // Trigger the file input click event
    if (fileInputRef.current) {
      fileInputRef.current.click();
    }
  };
  const handleAddCoverImage = () => {
    // Trigger the file input click event
    if (CoverInputRef.current) {
      CoverInputRef.current.click();
    }
  };

  const handlePropertyImage = async (event: ChangeEvent<HTMLInputElement>) => {
    const selectedFiles = event.target.files;
    if (selectedFiles && selectedFiles.length > 0) {
      const file = selectedFiles[0];
      //console.log(file);
      try {

        setLoadingImages(true);
        const s3 = new ReactS3Client({
          ...s3Config,
          dirName: 'profiles'
        });

        const res = await s3.uploadFile(file);
        console.log(res);

        setGalleryImgs((prevGalleryImgs) => [...(prevGalleryImgs || []), res.location]);
        setLoadingImages(false);
        if (fileInputRef.current) {
          fileInputRef.current.value = '';
        }


      } catch (exception) {
        console.error('Error uploading image:', exception);
        setLoadingImages(false);
        if (fileInputRef.current) {
          fileInputRef.current.value = '';
        }
      }
    }
  };

  const toPrevtStep = () => {
    const propertyInfo = {
      property,
      agent,
    };

    navigate('/add-listing-2', { state: propertyInfo });
  };

  const handleDeleteGalleryImage = (index:number) => {
    console.log("borrando property image en idex: " + index);
    const updatedGalleryImgs = [...(galleryImgs ?? [])];

  
    updatedGalleryImgs.splice(index, 1);
  
    setGalleryImgs(updatedGalleryImgs);
  };

  const handleDeleteCoverImage = () => {
    // console.log("borrando");
    setCoverImage('');
    property.featuredImage = '';
  };


  const renderGallery = () => {
    return (
      // <div className="flex flex-col ">

      <div className="border-dashed relative flex-col w-full h-[400px] rounded-md overflow-hidden  bg-[white] ">
        {coverImage ? (
          <div className=" group">
            <img
              className="absolute inset-0 object-cover rounded-sm sm:rounded-sm w-full h-full"
              src={coverImage}
              alt=""
              sizes="(max-width: 768px) 100vw, (max-width: 1200px) 50vw, 50vw"
            />
            <button
              className="absolute w-[30px] h-[30px] top-2 right-2 bg-red-500 text-white p-1 rounded-full opacity-0 group-hover:opacity-100 transition-opacity"
              onClick={handleDeleteCoverImage}
            >
              -
            </button>
          </div>
        ) : (
          loadingCover ? (
            <div className="flex items-center justify-center h-[400px]">
              <FadeLoader color="#36d7b7" />
            </div>
          ) : (

            <div className="relative z-10 flex-col w-full h-[400px] rounded-sm overflow-hidden  bg-transparent ">
              <div className="flex items-center justify-center h-[400px] px-6 pt-5 pb-6 border-2 border-neutral-300 dark:border-neutral-6000 border-dashed rounded-md">
                <div className="space-y-1 text-center">
                  <svg
                    className="mx-auto h-12 w-12 text-neutral-400"
                    stroke="currentColor"
                    fill="none"
                    viewBox="0 0 48 48"
                    aria-hidden="true"
                  >
                    <path
                      d="M28 8H12a4 4 0 00-4 4v20m32-12v8m0 0v8a4 4 0 01-4 4H12a4 4 0 01-4-4v-4m32-4l-3.172-3.172a4 4 0 00-5.656 0L28 28M8 32l9.172-9.172a4 4 0 015.656 0L28 28m0 0l4 4m4-24h8m-4-4v8m-12 4h.02"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    ></path>
                  </svg>
                  <div className="flex text-sm text-neutral-6000 dark:text-neutral-300">
                    <label
                      htmlFor="file-upload"
                      className="relative  font-medium text-primary-6000 "

                    >
                      <span>Upload a cover Image</span>
                     
                    </label>
                    <p className="pl-1"></p>
                  </div>
                  <p className="text-xs text-neutral-500 dark:text-neutral-400">
                    PNG, JPG up to 10MB
                  </p>
                </div>
              </div>
            </div>
          ))}
      </div>

    );
  };


  return (

    <div
      className={`nc-PageAddListing2 px-4 max-w-3xl mx-auto pb-24 pt-14 sm:py-24 lg:pb-32`}
      data-nc-id="PageAddListing2"
    >
      <div className="space-y-11">
        <div>
          <span className="text-4xl font-semibold">3</span>{" "}
          <span className="text-lg text-neutral-500 dark:text-neutral-400">
            / 5
          </span>
        </div>
        <div>
          <h2 className="text-2xl font-semibold">Property Images</h2>

        </div>
        <div className="listingSection__wrap ">
          <div className="space-y-8">
            <div>
              <input
                type="file"
                style={{ display: 'none' }}
                ref={CoverInputRef}
                onChange={handleCoverImageChange}
              />
              <ButtonSecondary onClick={handleAddCoverImage}> Add Cover Image + </ButtonSecondary>

            </div>
            {renderGallery()}
            <div className="flex flex-row items-center">
              <div>
                <input
                  type="file"
                  style={{ display: 'none' }}
                  ref={fileInputRef}
                  onChange={handlePropertyImage}
                />
                <ButtonSecondary onClick={handleAddImage}> Add Property Images + </ButtonSecondary>
             
             
              </div>
              {loadingImages && (
                <div className="pl-[40px]">
                  <FadeLoader color="#36d7b7" />
                </div>
              )}
            </div>

            {galleryImgs?.length === 0 ? ( 

<div className="relative z-10 flex-col w-[330px] h-[165px] rounded-sm overflow-hidden  bg-transparent ">
<div className="flex items-center justify-center h-[165px] px-6 pt-5 pb-6 border-2 border-neutral-300 dark:border-neutral-6000 border-dashed rounded-md">
  <div className="space-y-1 text-center">
    <svg
      className="mx-auto h-12 w-12 text-neutral-400"
      stroke="currentColor"
      fill="none"
      viewBox="0 0 48 48"
      aria-hidden="true"
    >
      <path
        d="M28 8H12a4 4 0 00-4 4v20m32-12v8m0 0v8a4 4 0 01-4 4H12a4 4 0 01-4-4v-4m32-4l-3.172-3.172a4 4 0 00-5.656 0L28 28M8 32l9.172-9.172a4 4 0 015.656 0L28 28m0 0l4 4m4-24h8m-4-4v8m-12 4h.02"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      ></path>
    </svg>
    <div className="flex text-sm text-neutral-6000 dark:text-neutral-300">
      <label
        htmlFor="file-upload"
        className="relative  font-medium text-primary-6000 "

      >
        <span>Upload Property Images</span>
        
      </label>
      <p className="pl-1"></p>
    </div>
    <p className="text-xs text-neutral-500 dark:text-neutral-400">
      PNG, JPG up to 10MB
    </p>
  </div>
</div>
</div>

            ) : (
              <div className="grid grid-cols-2 gap-[2px] scroll-top-0  ">
                {galleryImgs?.map((item, index) => (
                  <div
                    key={index}
                    className={`border-dashed border-2 border-neutral-300 relative rounded-sm overflow-hidden `}
                  >
                    <div className="relative flex-col rounded-md overflow-hidden  bg-[white] aspect-w-6 aspect-h-3 ">
                      <div className="group">
                        <img
                          className="absolute inset-0 object-cover rounded-sm sm:rounded-sm w-full h-full"
                          src={item || ""}
                          alt=""
                        />
                        <button
                          className="absolute  w-[30px] h-[30px] top-2 right-2 bg-red-500 text-white p-1 rounded-full cursor-pointer"
                          onClick={() => handleDeleteGalleryImage(index)}
                        >
                          -
                        </button>
                      </div>
                    </div>
                  </div>
                ))}
            </div>
            )}


          </div>

        </div>
        <div className="flex justify-end space-x-5">
          <ButtonSecondary onClick={toPrevtStep}>Go back</ButtonSecondary>
          <ButtonPrimary onClick={toNextStep}> {"Continue"} </ButtonPrimary>
        </div>
      </div>
    </div>
  );
};

export default PageAddListing4;
